import { Box } from '@mui/system';
import React, { CSSProperties } from 'react';
import MediumTypography from '../../components/formlib/MediumTypography';
import { translateTextArea } from '../../TranslateWidget';
import CommentTextbox from '../formlib/CommentTextbox';

type QuestionsType = {
  id: string;
  type: string;
  displayQNoId?: string;
  displayQueId: string;
  displayQNotext?: string;
  displayQuetext: string;
  displayMainQueId?: string;
  displayMainQuetext?: string;
};

const basicStyles: React.CSSProperties = {
  fontFamily: 'Lato-Regular',
  fontStyle: 'normal',
  fontWeight: 500,
  fontSize: '14px',
  paddingTop: '10px',
  paddingLeft: '10px',
  border: '1px solid #ccc',
  outline: 'none',
  overflow: 'hidden',
  borderRadius: '4px',
  transition: 'border-color 0.3s',
  alignItems: 'center',
  justifyContent: 'center',
  resize: 'none',
};

type ASQQuestionConcernComponentType = {
  questions: QuestionsType[];
  Value?: { commentId: number; comments: string }[];
  handlechange?: (
    value: { commentId: number; comments: string },
    index: number,
  ) => void;
  placeholder?: string;
  rows?: number;
  customCommentStyles?: CSSProperties;
  maxLength?: number;
  disabled?: boolean;
};

const SimpleTextAndTextArea = ({
  questions,
  placeholder,
  Value,
  handlechange,
  rows,
  customCommentStyles,
  maxLength,
  disabled,
}: ASQQuestionConcernComponentType) => {
  return (
    <Box>
      {questions?.map((questiondetails, index) => (
        <>
          {questiondetails.type === 'simpleQuestionWithTextArea' && (
            <>
              <Box sx={{ alignItems: 'center', display: 'inline-flex' }}>
                <MediumTypography
                  sxProps={{ fontSize: 14, fontWeight: 500 }}
                  labelid={questiondetails.displayQNoId}
                  defaultlabel={questiondetails.displayQNotext}
                />
                <MediumTypography
                  sxProps={{
                    marginLeft: '4px',
                    marginRight: '24px',
                    fontFamily: 'Lato-Regular',
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  labelid={questiondetails.displayQueId}
                  defaultlabel={questiondetails.displayQuetext}
                />
              </Box>
              <Box sx={{ paddingTop: '8px', width: '48%' }}>
                <CommentTextbox
                  className="translate"
                  name={questiondetails.displayQueId}
                  placeholder={placeholder}
                  rows={rows}
                  maxLength={maxLength}
                  Value={Value?.[index] ? Value[index].comments : ''}
                  handlechange={(value) => {
                    if (handlechange) {
                      handlechange(
                        { commentId: index, comments: value },
                        index,
                      );
                      translateTextArea(questiondetails.displayQueId);
                    }
                  }}
                  style={{
                    ...basicStyles,
                    ...customCommentStyles,
                  }}
                  disabled={disabled}
                />
              </Box>
            </>
          )}
          {questiondetails.type === 'multipleQuestionWithTextArea' && (
            <>
              <Box sx={{ marginTop: '8px' }}>
                <MediumTypography
                  sxProps={{ fontSize: 14, fontWeight: 600 }}
                  labelid={questiondetails.displayMainQueId}
                  defaultlabel={questiondetails.displayMainQuetext}
                />
              </Box>
              <Box sx={{ marginTop: '8px' }}>
                <MediumTypography
                  sxProps={{
                    marginRight: '24px',
                    fontFamily: 'Lato-Regular',
                    fontSize: 14,
                    fontWeight: 500,
                  }}
                  labelid={questiondetails.displayQueId}
                  defaultlabel={questiondetails.displayQuetext}
                />
              </Box>
              <Box sx={{ paddingTop: '8px', width: '48%' }}>
                <CommentTextbox
                  disabled={disabled}
                  placeholder={placeholder}
                  rows={rows}
                  name={questiondetails.displayQueId}
                  maxLength={maxLength}
                  Value={Value?.[index] ? Value[index].comments : ''}
                  handlechange={(value) =>
                    handlechange &&
                    handlechange({ commentId: index, comments: value }, index)
                  }
                  style={{
                    ...basicStyles,
                    ...customCommentStyles,
                  }}
                />
              </Box>
            </>
          )}
        </>
      ))}
    </Box>
  );
};

export default SimpleTextAndTextArea;
